import React from "react"
import { Provider } from "react-redux"
import { createStore, applyMiddleware } from "redux"
import thunk from "redux-thunk"

import AspCentres from "./AspCentres"
import reducers from "../store/reducers"

const store = createStore(reducers, applyMiddleware(thunk))

const AspCentresContainer = (props) => {
    return (
        <Provider store={store}>
            <AspCentres {...props} />
        </Provider>
    )
}

export default AspCentresContainer;